import {
  DEFAULT_VIEW_PREFERENCES,
  mergeViewPreferences,
  type ViewPreferences,
  type ViewPreferencesPatch,
} from '@pm/schemas';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

const KEY = ['view-preferences'] as const;

/** Filtros e modos de visualização salvos no servidor (voltam como a pessoa deixou). */
export function useViewPrefs() {
  const q = useQuery({
    queryKey: KEY,
    queryFn: () => api.get<ViewPreferences>('/me/preferences/views'),
    staleTime: Infinity,
  });
  // Falha ao ler não trava a tela: segue com o padrão.
  return { prefs: q.data ?? DEFAULT_VIEW_PREFERENCES, ready: q.isSuccess || q.isError };
}

/** Aplica na hora (otimista) e grava; se a gravação falhar, volta ao valor do servidor. */
export function useUpdateViewPrefs() {
  const qc = useQueryClient();
  const m = useMutation({
    mutationKey: KEY,
    mutationFn: (patch: ViewPreferencesPatch) =>
      api.patch<ViewPreferences>('/me/preferences/views', patch),
    onMutate: (patch) => {
      const prev = qc.getQueryData<ViewPreferences>(KEY) ?? DEFAULT_VIEW_PREFERENCES;
      qc.setQueryData<ViewPreferences>(KEY, mergeViewPreferences(prev, patch));
    },
    // Cliques seguidos: só a última resposta substitui o estado otimista.
    onSuccess: (saved) => {
      if (qc.isMutating({ mutationKey: KEY }) <= 1) qc.setQueryData(KEY, saved);
    },
    onError: () => void qc.invalidateQueries({ queryKey: KEY }),
  });
  return m.mutate;
}
